import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Tween, Easing } from '@tweenjs/tween.js';
import Game from '../../../Game';
import SpriteComponent from '../../../Component/Render/Sprite';
import Point from '../../../Utility/Point';
import { delay } from '../../../Utility/Task/TaskQueue';
import WorldSystem from '../../World/WorldSystem';

export class ArrowBounceLoopIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        meta = meta ? meta : {};
        const offset: Point = meta.offset ? meta.offset : new Point(0, 50);
        const speed: number = meta.speed ? meta.speed : 200;
        const transform = gameObject.getComponent(TransformComponent);
        const renderable: SpriteComponent = gameObject.getComponent(
            SpriteComponent
        );
        const tween: Tween = this.getTween(transform.position);
        const alphaTween: Tween = this.getTween(renderable);
        const initialPos: Point = transform.position.clone() as Point;
        const worldSystem: WorldSystem = Game.scene
            .getActiveScene()
            .getSystem(WorldSystem);

        renderable.alpha = 0;

        tween.easing(Easing.Quadratic.InOut);
        alphaTween.to({ alpha: 0 }, 200);
        yield* delay(500);
        while (true) {
            const harvestArrow: GameObject[] = GameObject.findByName(
                'harvest_arrow'
            );
            if (
                Game.store.getState().UIState.popupID === null &&
                harvestArrow === undefined &&
                !worldSystem.taskQueue.isRunning()
            ) {
                if (renderable.alpha < 1) {
                    alphaTween.to({ alpha: 1 }, 200).delay(500);
                    yield* this.startTween(alphaTween);
                }

                tween.to(
                    {
                        x: initialPos.x + offset.x,
                        y: initialPos.y + offset.y,
                    },
                    speed
                );

                yield* this.startTween(tween);
                tween.to({ x: initialPos.x, y: initialPos.y }, speed);
                yield* this.startTween(tween);
            } else {
                alphaTween.to({ alpha: 0 }, 200);
                yield* this.startTween(alphaTween);
            }
            yield;
        }
    }
}
